import { EnvService } from './env.service';

// Define a type for environment variables
export interface Environment {
  [key: string]: string | number | boolean | undefined;
}

declare global {
  interface Window {
    __env?: Partial<Environment>;
  }
}

export const EnvServiceFactory = (): Environment => {
  // Create an empty object to hold the environment variables
  const env: Environment = {};

  // Read environment variables from browser window
  const browserWindowEnv = window.__env || {};

  // Assign environment variables from browser window to env
  for (const key in browserWindowEnv) {
    if (Object.prototype.hasOwnProperty.call(browserWindowEnv, key)) {
      env[key] = browserWindowEnv[key];
    }
  }

  return env;
};

export const EnvServiceProvider = {
  provide: EnvService,
  useFactory: EnvServiceFactory,
  deps: [],
};
